import { EImageUsageCapacity } from "../../../domains/media/edges/UsedMediaEdge";
export var ENodeMetaType;
(function (ENodeMetaType) {
    ENodeMetaType["contact"] = "co";
    ENodeMetaType["location"] = "lo";
})(ENodeMetaType || (ENodeMetaType = {}));
export var ENodeMetaLocationSubType;
(function (ENodeMetaLocationSubType) {
    ENodeMetaLocationSubType["streetAddress"] = "lo_ad";
})(ENodeMetaLocationSubType || (ENodeMetaLocationSubType = {}));
export var ENodeMetaContactSubType;
(function (ENodeMetaContactSubType) {
    ENodeMetaContactSubType["phoneNumber"] = "co_ph";
    ENodeMetaContactSubType["email"] = "co_em";
})(ENodeMetaContactSubType || (ENodeMetaContactSubType = {}));
export var EPlaceNodeInfoLinkType;
(function (EPlaceNodeInfoLinkType) {
    EPlaceNodeInfoLinkType["isBrand"] = "i_br";
    EPlaceNodeInfoLinkType["isComplex"] = "i_co";
})(EPlaceNodeInfoLinkType || (EPlaceNodeInfoLinkType = {}));
export var ENodeParentType;
(function (ENodeParentType) {
    ENodeParentType["isParentOrg"] = "p_gr";
    ENodeParentType["isParentComplex"] = "p_co";
})(ENodeParentType || (ENodeParentType = {}));
export var ENodeAdminType;
(function (ENodeAdminType) {
    ENodeAdminType["isAdmin"] = "a_ad";
    ENodeAdminType["isEditor"] = "a_ed";
})(ENodeAdminType || (ENodeAdminType = {}));
export var ENodePermissionType;
(function (ENodePermissionType) {
    ENodePermissionType["ADMIN"] = "admin";
    ENodePermissionType["EDIT"] = "edit_details";
    ENodePermissionType["EDIT_TIME"] = "edit_time";
})(ENodePermissionType || (ENodePermissionType = {}));
export var ENodeType;
(function (ENodeType) {
    ENodeType["user"] = "us";
    ENodeType["team"] = "tm";
    ENodeType["geoLevel"] = "gl";
    ENodeType["tagOrTemplate"] = "ta";
    ENodeType["templateItemSuggestion"] = "ts";
    ENodeType["place"] = "pl";
    ENodeType["host"] = "ho";
    ENodeType["infoNode"] = "in";
    ENodeType["hostItem"] = "hi";
    ENodeType["temporaryHostItem"] = "th";
    ENodeType["hostMenu"] = "hm";
    ENodeType["listedNodeBlueprint"] = "lb";
    ENodeType["listedNode"] = "li";
    ENodeType["termOrCondition"] = "co";
    ENodeType["placeContext"] = "pc";
})(ENodeType || (ENodeType = {}));
export var ENodeStatus;
(function (ENodeStatus) {
    ENodeStatus["draft"] = "draft";
    ENodeStatus["live"] = "live";
    ENodeStatus["redirected"] = "redirected";
    ENodeStatus["disabled"] = "disabled";
    ENodeStatus["removed"] = "removed";
})(ENodeStatus || (ENodeStatus = {}));
export var EGeoCastingType;
(function (EGeoCastingType) {
    EGeoCastingType["point"] = "_point";
    EGeoCastingType["shape"] = "_shape";
    EGeoCastingType["exact_shape"] = "_exact_shape";
})(EGeoCastingType || (EGeoCastingType = {}));
export var EGeoLevelShortType;
(function (EGeoLevelShortType) {
    EGeoLevelShortType["cn"] = "cn";
    EGeoLevelShortType["cc"] = "cc";
    EGeoLevelShortType["st"] = "st";
    EGeoLevelShortType["mu"] = "mu";
    EGeoLevelShortType["ci"] = "ci";
    EGeoLevelShortType["su"] = "su";
    EGeoLevelShortType["ss"] = "ss";
})(EGeoLevelShortType || (EGeoLevelShortType = {}));
